let searchInputs = [
    {
        id: 'insuranceLine',
        label: 'Insurance Line',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'underwriter',
        label: 'Underwriter',
        type: 'select',
        options: []
    },
    {
        id: 'reseller',
        label: 'Reseller',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'incidentType',
        label: 'Incident Type',
        type: 'select',
        options: [
        ]
    },
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'imei',
        label: 'IMEI',
        type: 'text',
        placeholder: 'IMEI'
    },
    {
        id: 'serial',
        label: 'Serial',
        type: 'text',
        placeholder: 'Serial'
    },
    {
        id: 'processorToken',
        label: 'Processor Token',
        type: 'text',
        placeholder: 'Processor Token'
    }
]

export { searchInputs }